{
	"generic": "Что-то пошло не так. Попробуйте ещё раз.",
	"network": "Нет соединения с сервером",
	"offline": "Вы офлайн. Часть функций недоступна.",
	"unauthorized": "Требуется вход",
	"forbidden": "Нет доступа",
	"notFound": "Не найдено",
	"conflict": "Конфликт данных",
	"validation": "Проверьте введённые данные",
	"tooManyRequests": "Слишком много запросов. Подождите.",
	"serverError": "Ошибка сервера. Мы уже разбираемся.",
	"ai": {
		"failed": "AI временно недоступен. Мы повторим автоматически.",
		"timeout": "AI слишком долго не отвечает",
		"rateLimited": "Лимит AI исчерпан. Попробуйте позже.",
		"moderationBlocked": "Запрос отклонён модерацией"
	},
	"upload": {
		"failed": "Не удалось загрузить файл",
		"interrupted": "Загрузка прервана",
		"tooSlow": "Соединение слишком медленное"
	},
	"sync": {
		"failed": "Синхронизация не удалась",
		"conflict": "Обнаружен конфликт. Обновите страницу.",
		"retrying": "Повторная синхронизация…"
	},
	"actions": {
		"tryAgain": "Попробовать снова",
		"reportBug": "Сообщить об ошибке",
		"goHome": "На главную"
	},
	"featureTemporarilyDisabled": "Функция временно недоступна — мы уже занимаемся этим. Попробуйте чуть позже.",
	"moduleUnavailable": {
		"product_disabled": "Раздел отключён, поэтому действие недоступно.",
		"killed": "Раздел временно недоступен — мы уже разбираемся. Данные не пострадали.",
		"tier_locked": "Раздел доступен на более высоком тарифе. Обновите тариф, чтобы открыть его.",
		"platform_unsupported": "На этом устройстве раздел недоступен. Откройте StudyHub в браузере.",
		"dependency_missing": "Разделу нужен другой раздел, который сейчас отключён.",
		"external_down": "Внешний сервис раздела не отвечает. Попробуйте позже.",
		"lifecycle_removed": "Раздел выведен из эксплуатации. Уже созданные данные остаются доступны."
	},
	"aiDataSharingDenied": "Вы не разрешили отправлять данные AI-сервисам, поэтому эта AI-функция выключена. Включить её можно в Настройки → Приватность."
}
